export default __webpack_public_path__ + "static/media/videoedit.f3e1458a.gif";